"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _NeonDappKitLedgerServiceNeo3_instances, _NeonDappKitLedgerServiceNeo3_blockchainService, _NeonDappKitLedgerServiceNeo3_sendChunk, _NeonDappKitLedgerServiceNeo3_bip44PathToHex, _NeonDappKitLedgerServiceNeo3_derSignatureToHex;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeonDappKitLedgerServiceNeo3 = void 0;
const blockchain_service_1 = require("@cityofzion/blockchain-service");
const neon_dappkit_1 = require("@cityofzion/neon-dappkit");
const neon_js_1 = require("@cityofzion/neon-js");
const events_1 = __importDefault(require("events"));
var LedgerStatus;
(function (LedgerStatus) {
    LedgerStatus[LedgerStatus["OK"] = 36864] = "OK";
})(LedgerStatus || (LedgerStatus = {}));
var LedgerCommand;
(function (LedgerCommand) {
    LedgerCommand[LedgerCommand["GET_PUBLIC_KEY"] = 4] = "GET_PUBLIC_KEY";
    LedgerCommand[LedgerCommand["SIGN"] = 2] = "SIGN";
})(LedgerCommand || (LedgerCommand = {}));
var LedgerSecondParameter;
(function (LedgerSecondParameter) {
    LedgerSecondParameter[LedgerSecondParameter["MORE_DATA"] = 128] = "MORE_DATA";
    LedgerSecondParameter[LedgerSecondParameter["LAST_DATA"] = 0] = "LAST_DATA";
})(LedgerSecondParameter || (LedgerSecondParameter = {}));
class NeonDappKitLedgerServiceNeo3 {
    constructor(blockchainService, getLedgerTransport) {
        _NeonDappKitLedgerServiceNeo3_instances.add(this);
        _NeonDappKitLedgerServiceNeo3_blockchainService.set(this, void 0);
        this.emitter = new events_1.default();
        __classPrivateFieldSet(this, _NeonDappKitLedgerServiceNeo3_blockchainService, blockchainService, "f");
        this.getLedgerTransport = getLedgerTransport;
    }
    getAccount(transport, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const bip44Path = __classPrivateFieldGet(this, _NeonDappKitLedgerServiceNeo3_blockchainService, "f").bip44DerivationPath.replace('?', index.toString());
            const bip44PathHex = __classPrivateFieldGet(this, _NeonDappKitLedgerServiceNeo3_instances, "m", _NeonDappKitLedgerServiceNeo3_bip44PathToHex).call(this, bip44Path);
            const result = yield __classPrivateFieldGet(this, _NeonDappKitLedgerServiceNeo3_instances, "m", _NeonDappKitLedgerServiceNeo3_sendChunk).call(this, transport, LedgerCommand.GET_PUBLIC_KEY, 0x00, LedgerSecondParameter.LAST_DATA, bip44PathHex);
            const publicKey = result.toString('hex').substring(0, 130);
            const { address } = new neon_js_1.wallet.Account(publicKey);
            return {
                address,
                key: publicKey,
                type: 'publicKey',
                bip44Path,
            };
        });
    }
    getAccounts(transport) {
        return __awaiter(this, void 0, void 0, function* () {
            const accountsByBlockchainService = yield (0, blockchain_service_1.fetchAccountsForBlockchainServices)([__classPrivateFieldGet(this, _NeonDappKitLedgerServiceNeo3_blockchainService, "f")], (_service, index) => __awaiter(this, void 0, void 0, function* () {
                return this.getAccount(transport, index);
            }));
            const accounts = accountsByBlockchainService.get(__classPrivateFieldGet(this, _NeonDappKitLedgerServiceNeo3_blockchainService, "f").blockchainName);
            return accounts !== null && accounts !== void 0 ? accounts : [];
        });
    }
    getSigningCallback(transport, account) {
        return (transaction, { witnessIndex, network }) => __awaiter(this, void 0, void 0, function* () {
            try {
                this.emitter.emit('getSignatureStart');
                if (!account.bip44Path) {
                    throw new Error('Account must have a bip 44 path to sign with Ledger');
                }
                const neonJsAccount = new neon_js_1.wallet.Account(account.key);
                const witnessScriptHash = neon_js_1.wallet.getScriptHashFromVerificationScript(transaction.witnesses[witnessIndex].verificationScript.toString());
                if (neonJsAccount.scriptHash !== witnessScriptHash) {
                    throw new Error('Invalid witness script hash');
                }
                const bip44PathHex = __classPrivateFieldGet(this, _NeonDappKitLedgerServiceNeo3_instances, "m", _NeonDappKitLedgerServiceNeo3_bip44PathToHex).call(this, account.bip44Path);
                // Send the BIP44 account as first chunk
                yield __classPrivateFieldGet(this, _NeonDappKitLedgerServiceNeo3_instances, "m", _NeonDappKitLedgerServiceNeo3_sendChunk).call(this, transport, LedgerCommand.SIGN, 0, LedgerSecondParameter.MORE_DATA, bip44PathHex);
                // Send the network magic as second chunk
                yield __classPrivateFieldGet(this, _NeonDappKitLedgerServiceNeo3_instances, "m", _NeonDappKitLedgerServiceNeo3_sendChunk).call(this, transport, LedgerCommand.SIGN, 1, LedgerSecondParameter.MORE_DATA, neon_dappkit_1.NeonParser.numToHex(network, 4, true));
                const serializedTransaction = transaction.serialize(false);
                // Split the serialized transaction into chunks of 510 bytes
                const chunks = serializedTransaction.match(/.{1,510}/g) || [];
                // Send all chunks except the last one
                for (let i = 0; i < chunks.length - 1; i++) {
                    // We plus 2 because we already sent 2 chunks before
                    const commandIndex = 2 + i;
                    yield __classPrivateFieldGet(this, _NeonDappKitLedgerServiceNeo3_instances, "m", _NeonDappKitLedgerServiceNeo3_sendChunk).call(this, transport, LedgerCommand.SIGN, commandIndex, LedgerSecondParameter.MORE_DATA, chunks[i]);
                }
                // Again, we plus 2 because we already sent 2 chunks before getting the chunks
                const lastChunkIndex = 2 + chunks.length;
                // Send the last chunk signaling that it is the last one and get the signature
                const response = yield __classPrivateFieldGet(this, _NeonDappKitLedgerServiceNeo3_instances, "m", _NeonDappKitLedgerServiceNeo3_sendChunk).call(this, transport, LedgerCommand.SIGN, lastChunkIndex, LedgerSecondParameter.LAST_DATA, chunks[chunks.length - 1]);
                if (response.length <= 2) {
                    throw new Error('Invalid signature returned from Ledger');
                }
                const signature = __classPrivateFieldGet(this, _NeonDappKitLedgerServiceNeo3_instances, "m", _NeonDappKitLedgerServiceNeo3_derSignatureToHex).call(this, response.toString('hex'));
                return signature;
            }
            finally {
                this.emitter.emit('getSignatureEnd');
            }
        });
    }
}
exports.NeonDappKitLedgerServiceNeo3 = NeonDappKitLedgerServiceNeo3;
_NeonDappKitLedgerServiceNeo3_blockchainService = new WeakMap(), _NeonDappKitLedgerServiceNeo3_instances = new WeakSet(), _NeonDappKitLedgerServiceNeo3_sendChunk = function _NeonDappKitLedgerServiceNeo3_sendChunk(transport, command, commandIndex, secondParameter, chunk) {
    return transport.send(0x80, command, commandIndex, secondParameter, Buffer.from(chunk, 'hex'), [LedgerStatus.OK]);
}, _NeonDappKitLedgerServiceNeo3_bip44PathToHex = function _NeonDappKitLedgerServiceNeo3_bip44PathToHex(path) {
    let result = '';
    const components = path.split('/');
    components.forEach(element => {
        let number = parseInt(element, 10);
        if (isNaN(number)) {
            return;
        }
        if (element.length > 1 && element[element.length - 1] === "'") {
            number += 0x80000000;
        }
        result += number.toString(16).padStart(8, '0');
    });
    return result;
}, _NeonDappKitLedgerServiceNeo3_derSignatureToHex = function _NeonDappKitLedgerServiceNeo3_derSignatureToHex(response) {
    const ss = new neon_js_1.u.StringStream(response);
    // The first byte is format. It is usually 0x30 (SEQ) or 0x31 (SET)
    // The second byte represents the total length of the DER module.
    ss.read(2);
    // Now we read each field off
    // Each field is encoded with a type byte, length byte followed by the data itself
    ss.read(1); // Read and drop the type
    const r = ss.readVarBytes();
    ss.read(1);
    const s = ss.readVarBytes();
    // We will need to ensure both integers are 32 bytes long
    const integers = [r, s].map(i => {
        if (i.length < 64) {
            i = '0'.repeat(i.length - 64) + i;
        }
        if (i.length > 64) {
            i = i.substr(-64);
        }
        return i;
    });
    return integers.join('');
};
